module.exports = __webpack_public_path__ + "static/media/fullScreen.c187199e.svg";